<template>
  <section class="thank-you">
    <div class="thank-you__mark" aria-hidden="true">
      <svg viewBox="0 0 48 48" width="48" height="48" fill="none">
        <circle cx="24" cy="24" r="22" stroke="currentColor" stroke-width="2.5" />
        <path d="M15 24.5l6 6 12-13" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <h1 class="title">{{ t('thankYouTitle') }}</h1>
    <p class="lede">{{ t('thankYouText') }}</p>

    <template v-if="portalLink">
      <a id="portal_button" class="btn btn-primary" :href="portalLink">{{ t('portalCta') }}</a>
      <p class="countdown">{{ t('thankYouRedirect', { s: secondsLeft }) }}</p>
    </template>
  </section>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useBrandStore } from '@/stores/brandStore'
import { useSubscriptionStore } from '@/stores/subscriptionStore'

const brandStore = useBrandStore()
const { brandConfig } = storeToRefs(brandStore)
const { t } = brandStore
const subscriptionStore = useSubscriptionStore()

const REDIRECT_AFTER_S = 6
const secondsLeft = ref(REDIRECT_AFTER_S)
let timer = null

// Portal hand-off carries the msisdn so the portal can auto-log the new subscriber in.
const portalLink = computed(() => subscriptionStore.portalHref(brandConfig.value))

onMounted(() => {
  if (!portalLink.value) return
  timer = setInterval(() => {
    secondsLeft.value -= 1
    if (secondsLeft.value > 0) return
    clearInterval(timer)
    window.location.assign(portalLink.value)
  }, 1000)
})

onBeforeUnmount(() => clearInterval(timer))
</script>

<style scoped>
.thank-you {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
  padding-top: var(--spacing-xl);
  text-align: center;
}

.thank-you__mark {
  color: var(--color-success);
  animation: pop 320ms ease-out;
}

.title {
  font-family: var(--font-display);
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.05;
  text-wrap: balance;
}

.lede {
  font-size: 0.95rem;
  line-height: 1.6;
  color: var(--color-text-secondary);
  max-width: 32ch;
  margin-bottom: var(--spacing-md);
}

.countdown {
  font-size: 0.8rem;
  color: var(--color-text-secondary);
}

@keyframes pop {
  from {
    transform: scale(0.6);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .thank-you__mark {
    animation: none;
  }
}
</style>
